import { Card, CardContent, Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

import { OrganismFrame } from '@/core/architecture'

type EventCardSkeletonProps = {
  width?: number
}

export const EventCardSkeleton: FC<EventCardSkeletonProps> = ({ width }) => (
  <OrganismFrame width={width}>
    <Card sx={{ borderRadius: 2 }}>
      <Skeleton variant="rectangular" height={160} />
      <CardContent sx={{ p: 4, '&:last-child': { pb: 4 } }}>
        <SkeletonText variant="h3" width="10%" sx={{ mb: 2 }} />
        <SkeletonText variant="h3" width="100%" sx={{ mb: 2 }} />
        <Stack>
          <SkeletonText variant="small" numberOfLine={2} />
        </Stack>
      </CardContent>
    </Card>
  </OrganismFrame>
)
